import gql from 'graphql-tag';

/**
 * Data of the block project-iab-tax-data ("IAB- und Steuerdaten"): the six tax fields of
 * `investmentDeductionAllowance`. Read through `Project.blocks.iabTaxData`, which checks the
 * block's read permission.
 */
export const PROJECT_IAB_TAX_DATA_FIELDS = gql`
  fragment projectIabTaxDataFields on ProjectIabTaxDataBlock {
    id
    number
    investmentDeductionAllowance {
      taxTable
      effectiveTaxRatePercent
      churchTaxRatePercent
      taxRatePercent
      taxableIncomeEur
      iabPercent
    }
  }
`;
